import React, {useState, useRef, useEffect} from 'react'
import {Button, Card, Input} from 'antd'
import styles from './index.module.less'
import {getUser} from '@/common/utils'
import SelectCompany from './components/selectCompany';

const {Meta} = Card
const {Search} = Input;
const DemoPage = (props: any) => {
  const buttonAuth = JSON.parse(localStorage.getItem('buttonAuth'));
  const [isVisible, setIsVisible] = useState(false);
  const listRef = useRef<any>()
  const user = getUser() || {}
  const [currentChose, setCurrentChose] = useState(null);
  const [list, setList] = useState([
    {
      id: '1',
      title: 'DreamHome演示',
      // key: Auth['deleteApplication'],
      detail: '说明：这里可以放一两项简单描述，不带操作，仅可点击查看详情',
      time: '更新时间：2023-11-10',
      path: 'https://presentation.shjmall.cn',
      src: require('@/assets/house.svg')
    },
    {
      id: '2',
      title: 'DreamHome',
      // key: Auth['addPackage'],
      detail: '说明：这里可以放一两项简单描述，不带操作，仅可点击查看详情',
      time: '更新时间：2023-11-10',
      path: '/deal',
      src: require('@/assets/house.svg')
    },
  ])

  useEffect(() => {
    // console.log('btnAuth', btnAuth['addPackage'])
  }, [])


  const onNext = (item) => {
    // if (item.id == '1') {
    // }
    console.log(user);

    if (item?.id == '2') {
      if (user?.currentDepartmentPosition?.companyCode == '001000000') {
        setCurrentChose(item);
        setIsVisible(true);
      } else {
        localStorage.setItem(
          'user',
          JSON.stringify(Object.assign(user, {
            primaryDepartPosition: {
              ...user?.primaryDepartPosition,
              companyCodeDeal: user?.currentDepartmentPosition?.companyCode
            }
          }))
        )
        window.open(item?.path);
      }
    } else {
      window.open(item?.path);
    }

  }

  const onSearch = (value, _e, info) => console.log(info?.source, value);

  const openWindow = () => {
    window.open(currentChose?.path)
  }

  return (
    <div className={styles.content}>
      <div className={styles.cardContent}>
        demo
        {
          list.map((item, index) => {
            if (buttonAuth[item?.key]) {
              return (
                <div className={styles.eachCard} key={index}>
                  <div className={styles.mainContent}>
                    <div className={styles.logo}>
                      <img src={item?.src} alt=""/>
                    </div>
                    <div className={styles.rightContent}>
                      <div className={styles.mainTitle}>{item?.title}</div>
                      <div className={styles.detail}>{item?.detail}</div>
                    </div>
                  </div>
                  <div className={styles.footer}>
                    <div className={styles.time}>
                      {item?.time}
                    </div>
                    <div>
                      <Button type="primary" onClick={() => onNext(item)}>进入</Button>
                    </div>
                  </div>
                </div>
              )
            } else {
              return null
            }
          })
        }
      </div>
      <SelectCompany
        title={''}
        open={isVisible}
        resourceTree={[]}
        onClose={() => {
          setCurrentChose(null)
          setIsVisible(false)
        }}
        reload={openWindow}
      />
    </div>
  )
}
export default DemoPage
